import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  Create,
  SimpleForm,
  TextInput,
  Edit,
  EditButton,
  Delete,
  Filter,
} from 'admin-on-rest/lib/mui';
//import { CategoriesList, CreateCategories, EditCategories, DeleteCategories } from './cuisine';

//import { Actions } from '../custom/actions';

export const CategoriesFilter = (props) => (
  <Filter {...props}>
    <TextInput label="times" source="times" />
  </Filter>
);

export const CategoriesList = (props) => (
    <List title="Categories"  filters={<CategoriesFilter />} sort={{ field: 'name', order: 'ASC' }} {...props}>
        <Datagrid>
          <TextField source="title" />
          <EditButton />
        </Datagrid>
    </List>
);

export const CreateCategories = (props) => (
  <Create {...props}>
    <SimpleForm redirect="list">
      <TextInput source="title" />
    </SimpleForm>
  </Create>
);

const PostTitle = ({ record }) => {
    return <span>{record ? `${record.title}` : ''}</span>;
};


export const EditCategories = (props) => (
  <Edit title={<PostTitle />} {...props}>
    <SimpleForm>
      <TextInput source="title" />
    </SimpleForm>
  </Edit>
);

export const DeleteCategories = (props) => <Delete {...props} />;



// WEBPACK FOOTER //
// ./src/pages/companies/categories.js